export default __webpack_public_path__ + "1da4fff6520574c64d2952173006c815.png";